import { render } from "./AnimateSprite.vue?vue&type=template&id=7d2c3acd&scoped=true&ts=true"
import script from "./AnimateSprite.vue?vue&type=script&lang=ts"
export * from "./AnimateSprite.vue?vue&type=script&lang=ts"

import "./AnimateSprite.vue?vue&type=style&index=0&id=7d2c3acd&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2c3acd"]])

export default __exports__